<style></style>
<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">
          클래스목록
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            회원관리(ID주문) → 클래스 목록
          </div>
        </h5>
        <div class="row">
          <div class="col-lg-3">
            <div class="main-card mb-3 card">
              <div class="card-body">
                <div style="width: 50%; float: left; height: 40px">
                  <span
                    style="
                      background: #01a4ff;
                      color: #fff;
                      font-weight: bold;
                      border-radius: 6px;
                      padding: 4px 8px;
                      font-size: 18px;
                    "
                    >GREEN1</span
                  >
                </div>
                <h6 style="font-size: 16px; text-align: right">
                  (GR3) 월요일19:00
                </h6>
                <table class="table" style="background: #f8f8f8">
                  <tr>
                    <td>학생</td>
                    <td style="text-align: right">
                      10명
                      <button class="btn btn-warning btn-sm">진행상황</button
                      ><button class="btn btn-danger btn-sm">숙제</button>
                    </td>
                  </tr>
                </table>
                <div class="flex_center">
                  <button
                    type="button"
                    class="btn btn-success"
                    data-toggle="modal"
                    data-target=".bd-example-modal-lg"
                  >
                    클래스수정
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-toggle="modal"
                    data-target=".bd-example-modal-delete"
                  >
                    클래스삭제
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer flex_center">
            <button
              type="button"
              class="btn btn-primary"
              data-toggle="modal"
              data-target=".bd-example-modal-new"
            >
              클래스 생성
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 클래스 수정 -->
  <div
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">클래스 수정</h5>
        </div>
        <div class="modal-body">
          <table class="table">
            <tbody>
              <tr>
                <td class="th_bg">클래스명</td>
                <td><input Type="text" /></td>
              </tr>
              <tr>
                <td class="th_bg">Grade</td>
                <td>
                  <div class="input-group mb-12">
                    <div class="input-group-prepend">
                      <select
                        class="custom-select flex_center"
                        id="inputGroupSelect01"
                      >
                        <option selected>GK</option>
                        <option value="1">GR1</option>
                        <option value="2">GR2</option>
                        <option value="3">GR3</option>
                        <option value="4">GR4</option>
                        <option value="5">GR5</option>
                        <option value="6">GR6</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th_bg">요일</td>
                <td>
                  <div class="input-group mb-12">
                    <div class="input-group-prepend">
                      <select
                        class="custom-select flex_center"
                        id="inputGroupSelect01"
                      >
                        <option selected>월</option>
                        <option value="1">화</option>
                        <option value="2">수</option>
                        <option value="3">목</option>
                        <option value="4">금</option>
                        <option value="5">토</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th_bg">시간</td>
                <td>
                  <div class="input-group mb-12">
                    <div class="input-group-prepend">
                      <select
                        class="custom-select flex_center"
                        id="inputGroupSelect01"
                      >
                        <option selected>12:00</option>
                        <option value="1">13:00</option>
                        <option value="2">14:00</option>
                        <option value="3">15:00</option>
                        <option value="4">16:00</option>
                        <option value="5">17:00</option>
                        <option value="5">18:00</option>
                        <option value="5">19:00</option>
                        <option value="5">20:00</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <span
            >소속 학생들의 인원 및 반 변경은 회원관리에서 설정해주시기
            바랍니다.</span
          >
        </div>
        <div class="modal-footer flex_center">
          <button type="button" class="btn btn-danger">수정</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            닫기
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 클래스 생성 -->
  <div
    class="modal fade bd-example-modal-new"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">클래스 생성</h5>
        </div>
        <div class="modal-body">
          <table class="table">
            <tbody>
              <tr>
                <td class="th_bg">클래스명</td>
                <td><input Type="text" /></td>
              </tr>
              <tr>
                <td class="th_bg">Grade</td>
                <td>
                  <div class="input-group mb-12">
                    <div class="input-group-prepend">
                      <select
                        class="custom-select flex_center"
                        id="inputGroupSelect01"
                      >
                        <option selected>GK</option>
                        <option value="1">GR1</option>
                        <option value="2">GR2</option>
                        <option value="3">GR3</option>
                        <option value="4">GR4</option>
                        <option value="5">GR5</option>
                        <option value="6">GR6</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th_bg">요일</td>
                <td>
                  <div class="input-group mb-12">
                    <div class="input-group-prepend">
                      <select
                        class="custom-select flex_center"
                        id="inputGroupSelect01"
                      >
                        <option selected>월</option>
                        <option value="1">화</option>
                        <option value="2">수</option>
                        <option value="3">목</option>
                        <option value="4">금</option>
                        <option value="5">토</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th_bg">시간</td>
                <td>
                  <div class="input-group mb-12">
                    <div class="input-group-prepend">
                      <select
                        class="custom-select flex_center"
                        id="inputGroupSelect01"
                      >
                        <option selected>12:00</option>
                        <option value="1">13:00</option>
                        <option value="2">14:00</option>
                        <option value="3">15:00</option>
                        <option value="4">16:00</option>
                        <option value="5">17:00</option>
                        <option value="5">18:00</option>
                        <option value="5">19:00</option>
                        <option value="5">20:00</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <span
            >소속 학생들의 인원 및 반 변경은 회원관리에서 설정해주시기
            바랍니다.</span
          >
        </div>
        <div class="modal-footer flex_center">
          <button type="button" class="btn btn-danger">생성</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            닫기
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 클래스 삭제 -->
  <div
    class="modal fade bd-example-modal-delete"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">클래스 삭제</h5>
        </div>
        <div class="modal-body">
          <span
            >클래스 삭제는 해당 클래스에 등록된 회원이 없어야 삭제가 가능하면
            복구가 불가능하니 신중하게 해주시기 바랍니다.</span
          >
        </div>
        <div class="modal-footer flex_center">
          <button type="button" class="btn btn-danger">클래스 삭제</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            닫기
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body">
    <h1 class="mt-4"></h1>

    {{ this.records }}
  </div>
</template>
<style>
.hidtype {
  border: 0;
  text-align: center;
}

.hidtype-error {
  color: red;
}

.hidtype-changed {
  color: goldenrod;
}
</style>
<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import axios from "axios";
export default {
  name: "Home",
  components: {
    Tree,
  },
  mounted() {
    this.search();
  },
  methods: {
    doChange(name, value) {
      if (this.selData[name] === value) {
        delete this.changedData[name];
      } else {
        this.changedData[name] = value;
      }
    },
    selectedBiz(biz) {
      this.selBiz = biz;
    },
    search() {
      axios.get("/students").then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.records = response.data.result;
        }
      });
    },
    moreStudentInfo(record) {
      this.creating = false;
      this.changedData = {};
      this.selData = record;
      axios.get("/students/" + record.id).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.selData = {
            ...this.selData,
            ...response.data.result,
          };
        }
      });
    },

    doSend() {
      // 업데이트일 경우 patch /businesses/번호
      // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
      var data = {};
      if (this.creating) {
        data = {
          ...this.selData,
          ...this.changedData,
          activeBusiness: this.selBiz.id,
        };
      } else {
        data = this.changedData;
      }
      axios({
        method: this.creating ? "post" : "patch",
        url: "/students" + (!this.creating ? "/" + this.selData.id : ""),
        data: data,
      }).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
        }
      });
    },
    creatingMode() {
      this.selData = {
        id: "",
        activeBusiness: "",
        username: "",
        password: "",
        hanName: "",
        engName: "",
        parentName: "",
        gender: "",
        bookclub_status: "",
        vocajoa_status: "",
        uracle_status: "",
        birth_of_day: "",
        phone: "",
        parentName: "",
        parentPhone: "",
        address: "",
      };
      this.creating = true;
      this.changedData = {};
    },
  },
  data() {
    return {
      records: [],
      selBiz: {
        name: "",
      },
      selData: {
        id: "",
        activeBusiness: "",
        username: "",
        password: "",
        hanName: "",
        engName: "",
        parentName: "",
        gender: "",
        bookclub_status: "",
        vocajoa_status: "",
        uracle_status: "",
        birth_of_day: "",
        phone: "",
        parentName: "",
        parentPhone: "",
        address: "",
      },
      changedData: {},
      creating: true,
    };
  },
};
</script>
